import * as React from "react";
import Map, { Source, Layer, NavigationControl } from "react-map-gl/mapbox";
import "mapbox-gl/dist/mapbox-gl.css";
import MapMarker from "../mapMarker/MapMarker";
import { useMemo } from "react";
import { useEffect } from "react";

const MAPBOX_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

const lineLayer = {
  id: "route",
  type: "line",
  source: "route",
  layout: {
    "line-join": "round",
    "line-cap": "round",
  },
  paint: {
    "line-color": "#45748C",
    "line-width": 3,
  },
};

const MapDisplayRoute = ({
  polyline,
  stopPoints = [],
  showNavigation = true,
}) => {
  const coordinates = useMemo(() => {
    return polyline?.length > 0
      ? polyline.map((point) => [point.longitude, point.latitude])
      : [];
  }, [polyline]);

  const center = coordinates.length > 0 ? coordinates[0] : [101.69589, 3.14977];

  const geojson = useMemo(
    () => ({
      type: "Feature",
      properties: {},
      geometry: {
        type: "LineString",
        coordinates,
      },
    }),
    [coordinates]
  );

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        border: "1px solid #ccc",
        border: "0.063rem solid #EAECF0",
        borderTop: "0.094rem solid #EAECF0",
        borderBottom: " 0.094rem solid #EAECF0",
        borderRadius: "0.75rem",
        overflow: "hidden",
      }}
    >
      <Map
        mapboxAccessToken={MAPBOX_ACCESS_TOKEN}
        initialViewState={{
          longitude: center[0],
          latitude: center[1],
          zoom: 10,
        }}
        style={{ width: "100%", height: "100%" }}
        mapStyle="mapbox://styles/asiamobiliti/ckb1yq6080opd1inb3lkdmbii"
      >
        {coordinates.length > 0 && (
          <Source id="route" type="geojson" data={geojson}>
            <Layer {...lineLayer} />
          </Source>
        )}

        {stopPoints.map((point, index) => (
          <MapMarker
            key={`stop-${index}`}
            coordinates={{
              latitude: point.latitude,
              longitude: point.longitude,
            }}
            sequence={point.sequence}
          />
        ))}

        {showNavigation && <NavigationControl />}
      </Map>
    </div>
  );
};

export default MapDisplayRoute;
